// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"f53895d7","346":"9fca6bb5","553":"9c5b9d57","694":"ae2d50b7","934":"36ca9c08"}[chunkId] + ".chunk.js";
};